import { useState } from "react";
import { guideSteps, faqs } from "@/mocks/chiguaHome";

export default function GuideFaq() {
  const [openFaq, setOpenFaq] = useState<number>(0);

  return (
    <section id="guide" className="scroll-mt-20 bg-[#fbf7f0]">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-16">
        {/* 使用指南 */}
        <div className="text-center">
          <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest text-orange-700">
            <i className="ri-lifebuoy-line"></i> Guide
          </span>
          <h2 className="mt-2 text-2xl font-extrabold tracking-tight text-stone-900 md:text-3xl">
            三步走 · 再也不怕走丢
          </h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-stone-500">
            记住下面这套用法，无论通道怎么波动，都能在几秒内回到正确入口。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4">
          {guideSteps.map((s) => (
            <div key={s.step} className="relative rounded-xl border border-stone-200 bg-white p-5 md:p-6">
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-orange-600 text-white">
                  <i className={`${s.icon} text-xl`}></i>
                </span>
                <span className="font-mono text-4xl font-extrabold text-stone-100">{s.step}</span>
              </div>
              <h3 className="mt-4 text-base font-bold text-stone-900">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-stone-600">{s.desc}</p>
            </div>
          ))}
        </div>

        {/* 常见问题 */}
        <div className="mt-16 grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest text-orange-700">
              <i className="ri-question-answer-line"></i> FAQ
            </span>
            <h2 className="mt-2 text-2xl font-extrabold tracking-tight text-stone-900 md:text-3xl">常见疑问</h2>
            <p className="mt-3 text-sm leading-relaxed text-stone-600">
              关于备用地址、永久地址、防屏蔽与客户端的常见问题都收在这里。没找到答案，就按顶部公告或客服入口再问一次。
            </p>
            <a
              href="#guide"
              className="mt-5 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-orange-200 bg-orange-50 px-4 py-2.5 text-sm font-semibold text-orange-700 transition-colors hover:bg-orange-100"
            >
              <i className="ri-customer-service-2-line"></i> 联系客服
            </a>
          </div>

          <div className="flex flex-col gap-3 lg:col-span-8">
            {faqs.map((f, idx) => {
              const open = openFaq === idx;
              return (
                <div key={f.q} className={`overflow-hidden rounded-xl border transition-colors ${open ? "border-orange-300 bg-white" : "border-stone-200 bg-white"}`}>
                  <button
                    type="button"
                    onClick={() => setOpenFaq(open ? -1 : idx)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="text-sm font-semibold text-stone-900 md:text-base">{f.q}</span>
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-orange-700 transition-transform ${open ? "bg-orange-100" : "bg-stone-100"}`}>
                      <i className={`ri-add-line text-base ${open ? "rotate-45" : ""} transition-transform`}></i>
                    </span>
                  </button>
                  {open && (
                    <p className="border-t border-stone-100 px-5 pb-5 pt-3 text-sm leading-relaxed text-stone-600">{f.a}</p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}